var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sort-column"},[_c('span',{staticClass:"sort-column__label",domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('span',{staticClass:"common-table__sort-arrow",class:{
          'common-table__sort-arrow_asc': _vm.isDesc,
          'common-table__sort-arrow_desc': _vm.isAsc,
          'sort-column_center': _vm.alignCenter
        }})])
}
var staticRenderFns = []

export { render, staticRenderFns }